import { ChangeEventHandler, ReactNode } from 'react'
import Button from './Button'

type FeedbackMsgTemplateProps = {
	title: string
	msg: ReactNode
	type: string
	value: string
	onChange: ChangeEventHandler<HTMLTextAreaElement>
	onSend: () => void
}

const FeedbackMsgTemplate = ({
	title,
	msg,
	type,
	value,
	onChange,
	onSend,
}: FeedbackMsgTemplateProps) => {
	return (
		<section className="postgame-message feedback-box">
			<h3 className="feedback-title">{title}</h3>
			{msg}
			<textarea
				className="feedback-box__textarea"
				id="feedback-message"
				data-type={type}
				rows={10}
				value={value}
				onChange={onChange}
				placeholder="Please pop your feedback in here and click the Send button. Thanks!"
			/>
			<div className="feedback-box__actions">
				<Button
					className="feedback-box__send"
					id="send-feedback-button"
					name="send-feedback"
					onClick={onSend}
				>
					Send
				</Button>
			</div>
		</section>
	)
}

export default FeedbackMsgTemplate
